import React, {memo} from 'react';

import {Box, TextField} from '@mui/material';

export const SimpleTextConfig: React.FC = memo(() => {
  return (
    <Box marginBottom={5}>
      <TextField
        variant="outlined"
        disabled
        fullWidth
        placeholder="Sua resposta"
      />
    </Box>
  );
});
